// extracted by mini-css-extract-plugin
export var planCard = "_sd-0";
export var planList = "_sd-1";